import { matchPath } from 'react-router';
import { combineReducers } from 'redux';

import { PATH } from 'constants/RoutesConstants';
import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import * as types from 'modules/screensaver/actionTypes';
import { SCREENSAVER_DETAILS } from 'modules/screensaver/constants';
import { createReducer } from 'utils/ReduxUtils';

export const detailsMatcher = ({ meta }) => meta?.target === SCREENSAVER_DETAILS;

export const loadingReducer = combineReducers({
  creating: loading(types.CREATE_SCREENSAVER, { global: { matcher: detailsMatcher } }),
  updating: loading(types.UPDATE_SCREENSAVER, { global: { matcher: detailsMatcher } }),
});

const onLocationChange = (_, { payload }) => {
  const details =
    matchPath(PATH.GROUP_CONFIG_SCREENSAVER_DETAILS.path, payload.location.pathname) ??
    matchPath(PATH.DEALER_CONFIG_SCREENSAVER_DETAILS.path, payload.location.pathname);
  return Boolean(details) && payload.action === 'REPLACE';
};

export default combineReducers({
  loading: loadingReducer,
  ready: createReducer(false, {
    [LOCATION_CHANGE]: onLocationChange,
    [types.SCREENSAVER_READY]: () => true,
  }),
});
